import type { Culture } from "@p2l/config";

import type { Translation } from "models";

export const getTranslatedData = (
  culture: Culture,
  translationHash: Translation
) => {
  switch (culture) {
    case "en-GB":
      return translationHash.en;
    case "da-DK":
      return translationHash.dk;
    case "fi-FI":
      return translationHash.fi;
    case "kl-GL":
      return translationHash.gl;
    case "nn-NO":
      return translationHash.nn;
    case "pl-PL":
      return translationHash.pl;
    case "sv-SE":
      return translationHash.se;
    default:
      break;
  }
};
